var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"logo-box"},[_c('a',{staticClass:"logo",attrs:{"href":"#"}},[_c('img',{attrs:{"src":require("../../assets/icon/logo.svg"),"alt":""}})]),_c('h1',[_vm._v("家承智新")])])
}]

export { render, staticRenderFns }